module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }